module.exports = __webpack_public_path__ + "static/media/flagged-card-footer.5a288b0a.png";